import { useEffect } from "react";
import { useUserStore } from "@/store/zustand/useUserStore";

import auth from "@/api/auth";
import customerIo from "@/customer-io";
import { isFeatureEnabled } from "@/flags";
import hotjar from "@/hotjar";
import logrocket from "@/logrocket";
import mixpanel from "@/mixpanel";

if (isFeatureEnabled(import.meta.env.VITE_MIXPANEL_ENABLED)) {
  mixpanel.init();
  logrocket.init(mixpanel);

  if (isFeatureEnabled(import.meta.env.VITE_INTERCOM_ENABLED)) {
    window.Intercom("boot", {
      api_base: "https://api-iam.intercom.io",
      app_id: "r1jkch8u",
    });
  }
}

const MixpanelProvider = ({
  children
}) => {
  const user = useUserStore((state) => state.user);
  useEffect(() => {
    if (user) {
      const team = auth.team();
      mixpanel.identify(user.id);
      mixpanel.people.set({
        $name: user.name,
        $email: user.email,
        "Created At": user.created_at,
        "Email Verified At": user.email_verified_at,
        "Dashboard Ready": user.dashboard_ready,
        "Has Clients": user.has_clients,
        "Has Colleagues": user.has_colleagues,
        "Has Google Platform": user.has_google_platform,
      });
      hotjar.identify({
        id: user.id,
        name: user.name,
        email: user.email,
        created_at: user.created_at,
      });
      logrocket.identify(user.id, {
        name: user.name,
        email: user.email,
        createdAt: user.created_at,
        emailVerifiedAt: user.email_verified_at,
        dashboardReady: user.dashboard_ready,
        hasClients: user.has_clients,
        hasColleagues: user.has_colleagues,
        hasGooglePlatform: user.has_google_platform,
      });
      if (isFeatureEnabled(import.meta.env.VITE_INTERCOM_ENABLED)) {
        window.Intercom("update", {
          email: user.email,
          name: user.name,
          user_id: user.id,
        });
      }
      if (import.meta.env.VITE_CUSTOMERIO_SITEID) {
        customerIo.identify({
          id: user.id,
          name: user.name,
          email: user.email,
          has_clients: user.has_clients ? "1" : "0",
          has_team_members: user.has_colleagues ? "1" : "0",
          has_google_platform: user.has_google_platform ? "1" : "0",
          has_microsoft_platform: user.has_microsoft_platform ? "1" : "0",
          has_intercom_platform: user.has_intercom_platform ? "1" : "0",
          team_id: team.id,
          is_owner: team.owner ? "1" : "0",
        });
      }
    }
  }, [user]);

  return children;
};

export default MixpanelProvider;
